import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type ThemeProps from "@/types/Theme";
import createSelectors from "@/store/selectors";

export type ThemeStoreProps = {
  theme: ThemeProps;
  changeTheme: () => void;
  setTheme: (theme: ThemeProps) => void;
};

const useThemeStore = create<ThemeStoreProps>()(
  persist(
    (set, get) => ({
      theme: "light",
      setTheme: (theme: ThemeProps) => set({ theme }),
      changeTheme: () =>
        set({
          theme: get().theme === "light" ? "dark" : "light",
        }),
    }),
    {
      name: "theme",
      partialize: (state) => ({ theme: state.theme }),
    }
  )
);

export default createSelectors(useThemeStore);